import React from "react";
import { FeeStatus, MatchStatus, RegistrationStatus } from "../../Base/AdoptionConstants";
import { Button, Tooltip, Typography } from "@material-ui/core";
import useAlerts from "../../Base/AlertProvider";
import { CheckCircleOutline, RemoveCircleOutline } from "@material-ui/icons";
import { updateRegistrationFeeStatus } from "../../Base/Services/RegistrationService";
import useAdminContext from "../AdminContextProvider";
import ButtonWithLoadingSpinner from "../../Base/Components/ButtonWithLoadingSpinner";
import PaginatedTableResults from "../../Base/Components/PaginatedTableResults";
import { searchMatches } from "../../Base/Services/MatchService";
import moment from "moment";

export default function MatchesForRegistrationSection({ registration }) {
  const adminContext = useAdminContext();
  const [defaultMatchCriteria] = React.useState({
    registrationId: registration.registrationId,
    sortBy: "matchStatus",
  });

  function getOtherRegistrantFromMatch(match) {
    if (match.adoptee.registrationId === registration.registrationId) {
      return match.relative;
    } else {
      return match.adoptee;
    }
  }

  const tableHeaders = [
    {
      headerName: "ID",
      getField: (row) => row.matchId,
      sortBy: "matchId",
    },
    {
      headerName: "Create Date",
      getField: (row) => {
        let timeFromNow = moment(row.createdDate).fromNow();
        timeFromNow = timeFromNow.charAt(0).toUpperCase() + timeFromNow.slice(1);
        return (
          <Tooltip title={moment(row.createdDate).format("LLL")}>
            <span>{timeFromNow}</span>
          </Tooltip>
        );
      },
      sortBy: "createdDate",
    },
    {
      headerName: "Matched To",
      getField: (row) => {
        const matchedTo = getOtherRegistrantFromMatch(row);
        return `${matchedTo.registrant.contactInformation.lastName}, ${matchedTo.registrant.contactInformation.firstName} (${matchedTo.userFriendlyId})`;
      },
    },
    {
      headerName: "Matched Status",
      getField: (row) => MatchStatus[row.matchStatus].label,
      sortBy: "matchStatus",
    },
    {
      headerName: "Actions",
      getField: (row) => (
        <>
          <Button variant="contained" color="inherit" size="small" onClick={() => adminContext.openMatchDialog(row)}>
            View Match Details
          </Button>
        </>
      ),
    },
  ];

  return (
    <PaginatedTableResults
      inputSearchCriteria={defaultMatchCriteria}
      tableColumns={tableHeaders}
      getTableResultsFunction={searchMatches}
      defaultRowsPerPage={5}
    />
  );
}
